"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*!
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * Licensed under the Amazon Software License (the "License"). You may not use this file except in compliance with the License. A copy of
 * the License is located at
 *     http://aws.amazon.com/asl/
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

var apollo_link_1 = require("apollo-link");

var apollo_link_retry_1 = require("apollo-link-retry");

var apollo_utilities_1 = require("apollo-utilities");

var BASE_TIME_MS = 100;
var JITTER_FACTOR = 100;
var MAX_DELAY_MS = 5 * 60 * 1000;

var getDelay = function getDelay(count) {
  return Math.pow(2, count) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
};

exports.SKIP_RETRY_KEY = '@@skipRetry';

exports.getEffectDelay = function (_action, retries) {
  var delay = getDelay(retries);
  return delay <= MAX_DELAY_MS ? delay : null;
};

exports.createRetryLink = function (origLink) {
  var _delay;

  var retryLink = new apollo_link_retry_1.RetryLink({
    attempts: function attempts(count, operation, error) {
      var _a = exports.SKIP_RETRY_KEY,
          _b = operation.variables[_a],
          skipRetry = _b === void 0 ? false : _b;

      if (error.statusCode >= 400 && error.statusCode < 500) {
        return false;
      }

      if (apollo_utilities_1.graphQLResultHasError({
        errors: error ? error.graphQLErrors : []
      })) {
        return false;
      }

      if (skipRetry) {
        return false;
      }

      _delay = getDelay(count);
      return _delay <= MAX_DELAY_MS;
    },
    delay: function delay(_count, _operation, _error) {
      return _delay;
    }
  });
  var link = apollo_link_1.ApolloLink.from([retryLink, origLink]);
  return new apollo_link_1.ApolloLink(function (operation, forward) {
    var _a = operation.variables,
        _b = exports.SKIP_RETRY_KEY,
        _c = _a[_b],
        skipRetry = _c === void 0 ? false : _c,
        otherVars = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);

    if (skipRetry) {
      operation.variables = otherVars;
    }

    return link.request(operation, forward);
  });
};